// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".needs-meals-tab .word-search-filter[data-v-2d0b7047]{min-width:336px}.needs-meals-tab .resident-group-filter[data-v-2d0b7047]{min-width:295px}.needs-meals-tab .table-option-text[data-v-2d0b7047]{min-width:113px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
